import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["preview"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
const SampleDataBadge = _ref => {
  let {
      preview
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Badge, Object.assign({
    use: "marigold",
    "data-test-id": "sample-data-badge",
    position: "absolute",
    insetBlockStart: preview ? '1500' : '0',
    insetInlineStart: "500",
    marginBlockStart: "1000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, restProps, {
    children: /*#__PURE__*/_jsx(Small, {
      use: "help",
      color: "icon-core-default",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-enablement.zeroState.sampleData"
      })
    })
  }));
};
export default SampleDataBadge;